(function () {
  window.ElevarDataLayer = window.ElevarDataLayer || [];

  // Arma y empuja el evento a partir de los data-* del boton. Esta extraido del
  // listener para que la wishlist propia pueda emitirlo cuando el cliente GUARDA
  // en el modal: el listener de abajo escucha en fase de CAPTURA, asi que ve el
  // click antes que el JS del modal y contaria tambien los que se cancelan.
  function pushAddToWishlist(btn) {
    if (!btn) return;

    var variantId = btn.getAttribute('data-varID') || '';
    var productId = btn.getAttribute('data-proID') || '';
    var price = (btn.getAttribute('data-gtm-price') || '').replace(/,/g, '');
    var compareAtPrice = (btn.getAttribute('data-gtm-compare-price') || '0.00').replace(/,/g, '');

    window.ElevarDataLayer.push({
      event: 'dl_add_to_wishlist',
      event_properties: {
        currency_code: 'MXN',
        products: [
          {
            id: String(variantId || ''),
            name: btn.getAttribute('data-gtm-name') || '',
            brand: btn.getAttribute('data-gtm-brand') || 'HIGH STREET',
            category: btn.getAttribute('data-gtm-category') || '',
            variant: '',
            price: price,
            list: btn.getAttribute('data-gtm-list') || window.location.pathname,
            product_id: String(productId || ''),
            variant_id:  String(variantId || ''),
            compare_at_price: compareAtPrice || '0.00',
            image: btn.getAttribute('data-gtm-image') || ''
          }
        ]
      }
    });
  }

  // Lo llama assets/wishlist-hearts.js cuando el guardado en un toque crea el
  // item (`created: true`), y assets/wishlist-modal.js cuando el producto entra
  // a favoritos desde el popup sin haber estado guardado antes.
  window.HSWishlistGTM = { addToWishlist: pushAddToWishlist };

  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest('.wishlist-btn');
      if (!btn) return;

      // Los corazones de la wishlist propia emiten el evento ellos mismos,
      // cuando el backend confirma el alta: aqui el click todavia no dice si
      // el producto entro. Los botones de Hulk no llevan este atributo, asi
      // que su camino no cambia en nada.
      if (btn.hasAttribute('data-wishlist-heart')) return;

      // Only fire when adding (data-added is false before this click)
      if (btn.getAttribute('data-added') !== 'false') return;

      pushAddToWishlist(btn);
    },
    true,
  );
})();
